export enum LoginDialogStyleType {
  COMMON = 0,
  SUBSCRIBED_BUT_NOT_NOT_LOGIN_STYLE = 1,
}
